import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppConfigService } from '../app-config/app-config.service';
import { AppConfigurationError } from '../app-config/app-configuration-error';

@Injectable({ providedIn: 'root' })
export class UrlService {
  private readonly _externalApiUrl = `${environment.externalApiBaseUrl}/api`;

  get API_URL() {
    const config = this.appConfigService.getConfig();
    if (!config) {
      throw new AppConfigurationError();
    }
    const hostname = window.location.hostname;
    let domain = '.pos.versacommerce.de';

    // Determine if this is a staging environment:
    // - environment.isStaging: true for mobile staging builds (iOS/Android apps built with staging tags)
    // - hostname.includes('pos-4-staging'): true for web staging environment (browser access)
    // Staging environments use .pos.versacommerce.eu domain, production uses .pos.versacommerce.de
    if (environment.isStaging || hostname.includes('pos-4-staging')) {
      domain = '.pos.versacommerce.eu';
    }

    // environment.production determines the connection type:
    // - true: Connect to remote server (production or staging)
    // - false: Connect to local dev server at '/pos-api' (for local development only)
    return environment.production ? `https://${config.shopName}${domain}/pos-api` : '/pos-api';
  }

  get EXTERNAL_API_URL() {
    return this._externalApiUrl;
  }

  constructor(private readonly appConfigService: AppConfigService) {
  }

}
